<template>
    <b-row class="mb-3">
        <b-col md="6">
            <b-row>
                <b-col md="5">
                    <h4>Jobs by ticket size</h4>
                </b-col>
                <b-col md="3">
                    <eb-select
                        id="selectedDate7"
                        type="text"
                        label="text"
                        v-model="selectedDate7"
                        :selected="selectedDate7.text"
                        @input="changeDate7"
                        :options="dateOption"
                    ></eb-select>
                    <c-date
                        ref="compRefs7"
                        modalRef="modalRef7"
                        modalId="dateModal7"
                        @customDateRange="findDateResult7"
                    ></c-date>
                </b-col>
                <b-col md="4">
                    <eb-select
                        type="select"
                        v-model="selectedCustomer1"
                        :options="customerList"
                        label="text"
                        :id="'selectCustomer1'"
                        @input="changeCustomer1"
                        :selected="selectedCustomer1"
                    ></eb-select>
                </b-col>
            </b-row>
            <b-card>
                <div
                    v-if="
                        chartData6 &&
                        chartData6.labels &&
                        chartData6.labels.length
                    "
                >
                    <BarChart
                        :chart-data="chartData6"
                        :chart-options="barChartOptions6"
                    />
                </div>
            </b-card>
        </b-col>
        <b-col md="6">
            <b-row>
                <b-col md="8">
                    <h4>Hours per by Tech Straight vs Overtime</h4>
                </b-col>
                <b-col md="4">
                    <eb-select
                        id="selectedDate3"
                        type="text"
                        label="text"
                        v-model="selectedDate3"
                        :selected="selectedDate3.text"
                        @input="changeDate3"
                        :options="dateOption"
                    ></eb-select>
                    <c-date
                        ref="compRefs3"
                        modalRef="modalRef3"
                        modalId="dateModal3"
                        @customDateRange="findDateResult3"
                    ></c-date>
                </b-col>
            </b-row>
            <b-card>
                <div
                    v-if="
                        chartData2 &&
                        chartData2.labels &&
                        chartData2.labels.length
                    "
                >
                    <BarChart
                        :chart-data="chartData2"
                        :chart-options="barChartOptions2"
                    />
                </div>
            </b-card>
        </b-col>
        <b-col md="6">
            <b-row>
                <b-col md="8">
                    <h4>Margin by Tech</h4>
                </b-col>
                <b-col md="4">
                    <eb-select
                        id="selectedDate4"
                        type="text"
                        label="text"
                        v-model="selectedDate4"
                        :selected="selectedDate4.text"
                        @input="changeDate4"
                        :options="dateOption"
                    ></eb-select>
                    <c-date
                        ref="compRefs4"
                        modalRef="modalRef4"
                        modalId="dateModal4"
                        @customDateRange="findDateResult4"
                    ></c-date>
                </b-col>
            </b-row>
            <b-card>
                <div
                    v-if="
                        chartData3 &&
                        chartData3.labels &&
                        chartData3.labels.length
                    "
                >
                    <BarChart
                        :chart-data="chartData3"
                        :chart-options="barChartOptions3"
                    />
                </div>
            </b-card>
        </b-col>
        <b-col md="6">
            <b-row>
                <b-col md="5">
                    <h4>Number of Tickets</h4>
                </b-col>
                <b-col md="3">
                    <eb-select
                        id="selectedDate5"
                        type="text"
                        label="text"
                        v-model="selectedDate5"
                        :selected="selectedDate5.text"
                        @input="changeDate5"
                        :options="dateOption"
                    ></eb-select>
                    <c-date
                        ref="compRefs5"
                        modalRef="modalRef5"
                        modalId="dateModal5"
                        @customDateRange="findDateResult5"
                    ></c-date>
                </b-col>
                <b-col md="4">
                    <eb-select
                        type="select"
                        v-model="selectedCustomer3"
                        :options="customerList"
                        label="text"
                        :id="'selectCustomer3'"
                        @input="changeCustomer2"
                        :selected="selectedCustomer3"
                    ></eb-select>
                </b-col>
            </b-row>
            <b-card>
                <div
                    v-if="
                        chartData4 &&
                        chartData4.labels &&
                        chartData4.labels.length
                    "
                >
                    <PieChart
                        :chart-data="chartData4"
                        :chart-options="barChartOptions4"
                    />
                </div>
            </b-card>
        </b-col>
        <b-col md="6">
            <b-row>
                <b-col md="5">
                    <h4>Non productive hours by tech</h4>
                </b-col>
                <b-col md="3">
                    <eb-select
                        style="background-color: #fff"
                        id="reportData6DateFilter"
                        type="text"
                        label="text"
                        v-model="selectedDate1"
                        :selected="selectedDate1.text"
                        @input="changeDate1"
                        :options="dateOption"
                    ></eb-select>
                    <c-date
                        ref="compRefs1"
                        modalRef="modalRef1"
                        modalId="dateModal1"
                        @customDateRange="findDateResult1"
                    ></c-date>
                </b-col>
                <b-col md="4">
                    <eb-select
                        type="select"
                        v-model="selectedCustomer2"
                        :options="customerList"
                        label="text"
                        :id="'selectCustomer2'"
                        @input="changeCustomer"
                        :selected="selectedCustomer2"
                    ></eb-select>
                </b-col>
            </b-row>
            <b-card>
                <div
                    v-if="
                        chartData1 &&
                        chartData1.labels &&
                        chartData1.labels.length
                    "
                >
                    <BarChart
                        :chart-data="chartData1"
                        :chart-options="barChartOptions1"
                    />
                </div>
            </b-card>
        </b-col>
        <b-col md="12">
            <b-card>
                <b-row>
                    <b-col><h4>SLA Report</h4></b-col>
                    <b-col md="2">
                        <eb-select
                            style="background-color: #fff"
                            id="reportData4DateFilter"
                            type="text"
                            label="text"
                            v-model="selectedDate8"
                            :selected="selectedDate8"
                            @input="changeDate6"
                            :options="dateOption"
                        ></eb-select>
                        <c-date
                            ref="compRefs6"
                            modalRef="modalRef6"
                            modalId="dateModal6"
                            @customDateRange="findDateResult6"
                        ></c-date>
                    </b-col>
                </b-row>
                <b-table
                    hover="hover"
                    :striped="false"
                    bordered="bordered"
                    small="small"
                    fixed="fixed"
                    :loading="slaReportLoading"
                    responsive="sm"
                    :items="slaReport.data"
                    :fields="fields"
                    thead-class="header"
                    show-empty
                ></b-table>
                <div style="float: right">
                    <b-pagination
                        v-model="currentPage"
                        :per-page="perPage"
                        :total-rows="slaReport.totalItems"
                        aria-controls="partner-table"
                        prev-text="Prev"
                        next-text="Next"
                        hide-goto-end-buttons
                        @change="onChangePage"
                    ></b-pagination>
                </div>
            </b-card>
        </b-col>
    </b-row>
</template>

<script>
import ebSelect from "@/components/FormElements/Select.vue";
import cDate from "@/components/FormElements/CustomDate.vue";
import BarChart from "@/components/chart/newBarChart.vue";
import PieChart from "@/components/chart/newPieChart.vue";
import moment from "moment";
import { mapState } from "vuex";

export default {
    name: "Reports",
    components: { ebSelect, cDate, BarChart, PieChart },
    data() {
        return {
            selectedCustomer1: {
                text: "All",
                value: "All",
            },
            selectedCustomer2: {
                text: "All",
                value: "All",
            },
            selectedCustomer3: {
                text: "All",
                value: "All",
            },

            selectedDate1: {
                text: "7 days",
                value: 6,
            },
            selectedDate3: {
                text: "7 days",
                value: 6,
            },
            selectedDate4: {
                text: "7 days",
                value: 6,
            },
            selectedDate5: {
                text: "7 days",
                value: 6,
            },

            selectedDate7: {
                text: "7 days",
                value: 6,
            },
            selectedDate8: {
                text: "Today",
                value: 0,
            },
            slaReportData: [],
            currentPage: 1,
            perPage: 20,
            slaReportLoading: false,
            fields: [
                {
                    label: "Job ID",
                    key: "Job_ID",
                },
                {
                    label: "Service Provided",
                    key: "Services_Provided",
                },
                {
                    label: "Day",
                    key: "Day",
                },
                {
                    label: "Resolution Status",
                    key: "sla_resolution_status",
                },
                {
                    label: "Response Status",
                    key: "sla_response_status",
                },
            ],
            dateOption: [
                {
                    text: "Today",
                    value: 0,
                },
                {
                    text: "7 days",
                    value: 6,
                },
                {
                    text: "30 days",
                    value: 29,
                },
                {
                    text: "Custom",
                    value: "custom",
                },
            ],
            startDate1: "",
            endDate1: "",
            startDate2: "",
            endDate2: "",

            startDate3: "",
            endDate3: "",
            startDate4: "",
            endDate4: "",
            startDate5: "",
            endDate5: "",

            startDate7: "",
            endDate7: "",
        };
    },
    computed: {
        ...mapState({
            slaReport: (state) => state.partner.slaReport,
        }),
        chartData2() {
            const dataList =
                this.$store.getters["partner/gethoursTechStraightOvertime"];
            const labels = [];
            const dataSets = [
                {
                    label: "Total Overtime Hours",
                    backgroundColor: "rgba(75, 192, 192, 0.6)",
                    data: [],
                    yAxisID: "y",
                },
                {
                    label: "Total Straight Hours",
                    backgroundColor: "rgba(255, 99, 132, 0.6)",
                    data: [],
                    yAxisID: "y2",
                },
            ];

            if (dataList && dataList["hours-per-by-tech-straight-overtime"]) {
                if (
                    dataList["hours-per-by-tech-straight-overtime"].length > 0
                ) {
                    dataList["hours-per-by-tech-straight-overtime"].map(
                        (el) => {
                            labels.push(el.Tech_Name);
                            dataSets[0].data.push(
                                parseInt(el.total_overtime_hours),
                            );
                            dataSets[1].data.push(
                                parseInt(el.total_straight_hours),
                            );
                        },
                    );
                }
            }

            return {
                labels,
                datasets: dataSets,
            };
        },
        barChartOptions2() {
            return {
                responsive: true,
                maintainAspectRatio: false,
                scales: {
                    y: {
                        display: true,
                        beginAtZero: true,
                        grid: {
                            display: false,
                            drawBorder: false,
                        },
                    },
                    y2: {
                        display: true,
                        beginAtZero: true,
                        suggestedMax: 3, // 👈 Adjusted to prevent stretching
                        grid: {
                            display: false,
                            drawBorder: false,
                        },
                        // position: "right",

                        ticks: {
                            display: false, // 👈 Ensure it only shows whole numbers
                        },
                    },
                    x: {
                        display: true,
                        ticks: {
                            display: true,
                        },
                        grid: {
                            display: false,
                            drawBorder: false,
                        },
                    },
                },
            };
        },
        chartData3() {
            const dataList =
                this.$store.getters["partner/getNumberOfMarginByTech"];
            const labels = [];
            const dataSets = [
                {
                    label: "Total Cost",
                    backgroundColor: "rgba(75, 192, 192, 0.6)",
                    data: [],
                },
                {
                    label: "Total Revenue",
                    backgroundColor: "rgba(255, 99, 132, 0.6)",
                    data: [],
                },
                {
                    label: "Margin",
                    backgroundColor: "#2554FF",
                    data: [],
                },
            ];

            if (dataList && dataList["margin-by-tech"]) {
                if (dataList["margin-by-tech"].length > 0) {
                    dataList["margin-by-tech"].map((el) => {
                        labels.push(el.Tech_Name);
                        dataSets[0].data.push(parseInt(el.total_cost));
                        dataSets[1].data.push(parseInt(el.total_revenue));
                        dataSets[2].data.push(parseInt(el.margin));
                    });
                }
            }

            return {
                labels,
                datasets: dataSets,
            };
        },
        barChartOptions3() {
            return {
                responsive: true,
                maintainAspectRatio: false,
                scales: {
                    y: {
                        display: true,
                        beginAtZero: true,
                        grid: {
                            display: false,
                            drawBorder: false,
                        },
                    },
                    x: {
                        display: true,
                        ticks: {
                            display: true,
                        },
                        grid: {
                            display: false,
                            drawBorder: false,
                        },
                    },
                },
            };
        },
        chartData4() {
            const isAllSelected2 =
                this.selectedCustomers2 &&
                this.selectedCustomers2.toLowerCase() === "all";
            const data = this.$store.getters["partner/getNumberOfTickets"];
            const dsoKey2 = isAllSelected2
                ? "all-number-of-tickets"
                : "number-of-tickets";

            // Define labels and dataset structure
            const labels = ["Opened", "WIP", "Closed"];
            const dataSets = [
                {
                    data: [], // Populate dynamically
                    backgroundColor: [
                        "#FF6384", // Red
                        "#36A2EB", // Light Blue
                        "#FFCD56", // Yellow
                    ],
                    hoverBackgroundColor: [
                        "#FF8A80", // Hover Red
                        "#42A5F5", // Hover Light Blue
                        "#FFD54F", // Hover Yellow
                    ],
                },
            ];

            // Extract and bind the data from API response
            if (data && data[dsoKey2]) {
                if (data[dsoKey2].length > 0) {
                    const ticketData = data[dsoKey2][0]; // First object in array
                    dataSets[0].data.push(
                        parseInt(ticketData.opened_tickets), // Opened
                        parseInt(ticketData.wip_tickets), // WIP
                        parseInt(ticketData.closed_tickets), // Closed
                    );
                }
            }

            return {
                labels,
                datasets: dataSets,
            };
        },
        barChartOptions4() {
            return {
                responsive: true,
                maintainAspectRatio: false,
            };
        },

        chartData6() {
            const isAllSelected =
                this.selectedCustomer &&
                this.selectedCustomer.toLowerCase() === "all";
            const dataList =
                this.$store.getters["partner/getNumberOfJobsByTicketSize"];
            const dsoKey = isAllSelected
                ? "all-number-of-jobs-by-ticket-size"
                : "number-of-jobs-by-ticket-size";
            const labels = [];
            const backgroundColors = [];
            const dataSets = [
                {
                    label: "Num of Jobs",
                    backgroundColor: backgroundColors,
                    data: [],
                },
            ];

            if (dataList && dataList[dsoKey]) {
                if (dataList[dsoKey].length > 0) {
                    dataList[dsoKey].map((el) => {
                        labels.push(el.ticket_size);
                        dataSets[0].data.push(parseInt(el.num_of_jobs));
                        switch (el.ticket_size.toLowerCase()) {
                            case "small":
                                backgroundColors.push(
                                    "rgba(75, 192, 192, 0.6)",
                                );
                                break;
                            case "medium":
                                backgroundColors.push(
                                    "rgba(255, 206, 86, 0.6)",
                                );
                                break;
                            case "large":
                                backgroundColors.push(
                                    "rgba(255, 99, 132, 0.6)",
                                );
                                break;
                            default:
                                backgroundColors.push(
                                    "rgba(153, 102, 255, 0.6)",
                                );
                        }
                    });
                }
            }

            return {
                labels,
                datasets: dataSets,
            };
        },
        barChartOptions6() {
            return {
                responsive: true,
                maintainAspectRatio: false,
                scales: {
                    y: {
                        display: true,
                        beginAtZero: true,
                        grid: {
                            display: false,
                            drawBorder: false,
                        },
                    },
                    x: {
                        display: true,
                        ticks: {
                            display: true,
                        },
                        grid: {
                            display: false,
                            drawBorder: false,
                        },
                    },
                },
            };
        },
        chartData1() {
            const isAllSelected1 =
                this.selectedCustomers1 &&
                this.selectedCustomers1.toLowerCase() === "all";
            const dataList =
                this.$store.getters["partner/getNoOfNonProdHoursByTech"];
            const dsoKey1 = isAllSelected1
                ? "all-non-productive-hours-by-tech"
                : "non-productive-hours-by-tech";
            const labels = [];
            const dataSets = [
                {
                    label: "Non-Productive Hours Overtime",
                    backgroundColor: "rgba(54, 162, 235, 0.6)",
                    data: [],
                },
                {
                    label: "Non-Productive Hours Straight",
                    backgroundColor: "rgba(255, 159, 64, 0.6)",
                    data: [],
                },
                {
                    label: "Total Non-Productive Hours",
                    backgroundColor: "rgba(75, 192, 192, 0.6)",
                    data: [],
                },
            ];

            if (dataList && dataList[dsoKey1]) {
                if (dataList[dsoKey1].length > 0) {
                    dataList[dsoKey1].map((el) => {
                        labels.push(el.Tech_Name);
                        dataSets[0].data.push(
                            parseFloat(
                                el.non_productive_hours_overtime,
                            ).toFixed(2),
                        );
                        dataSets[1].data.push(
                            parseFloat(
                                el.non_productive_hours_straight,
                            ).toFixed(2),
                        );
                        dataSets[2].data.push(
                            parseFloat(el.total_non_productive_hours).toFixed(
                                2,
                            ),
                        );
                    });
                }
            }
            return {
                labels,
                datasets: dataSets,
            };
        },
        barChartOptions1() {
            const isAllSelected1 =
                this.selectedCustomers1 &&
                this.selectedCustomers1.toLowerCase() === "all";
            const dsoKey1 = isAllSelected1
                ? "all-non-productive-hours-by-tech"
                : "non-productive-hours-by-tech";
            return {
                responsive: true,
                maintainAspectRatio: false,
                scales: {
                    x: {
                        stacked: false,
                        grid: {
                            display: false,
                            drawBorder: false,
                        },
                    },
                    y: {
                        stacked: false,
                        grid: {
                            display: false,
                            drawBorder: false,
                        },
                    },
                },
                plugins: {
                    tooltip: {
                        callbacks: {
                            label: (tooltipItem) => {
                                let data =
                                    this.$store.getters[
                                        "partner/getNoOfNonProdHoursByTech"
                                    ];
                                if (data && data[dsoKey1]) {
                                    const item = data[dsoKey1].find(
                                        (el) =>
                                            el.Customer_Name ===
                                            tooltipItem.label,
                                    );
                                    if (item) {
                                        return `${item.Type}: ${tooltipItem.raw}`;
                                    }
                                }
                                return tooltipItem.raw;
                            },
                        },
                    },
                },
            };
        },

        customerList() {
            let data = this.$store.getters["partner/getCustomerListData"];
            const customerDataList = data["customer-list"]
                ? data["customer-list"].map((d) => {
                      return {
                          text: d.Customer_Name,
                          value: d.Customer_Name,
                      };
                  })
                : [];
            customerDataList.unshift({ text: "All", value: "all" });
            return customerDataList;
        },
    },
    methods: {
        changeDate3(e) {
            this.selectedDate3 = e;
            if (e.value == "custom") {
                this.$refs["compRefs3"].openModal();
                return;
            }
            this.fetchHoursTechStraightOvertime();
        },
        findDateResult3(e) {
            this.startDate3 = e.fromDate;
            this.endDate3 = e.toDate;
            this.fetchHoursTechStraightOvertime();
        },

        getDateData3(dateData) {
            if (dateData == "custom") {
                const data = {
                    fromDate: this.startDate3,
                    toDate: this.endDate3,
                };
                return data;
            }
            if (dateData == 1) {
                const data = {
                    fromDate: moment().format("YYYY-MM-DD"),
                    toDate: moment().add(1, "days").format("YYYY-MM-DD"),
                };
                return data;
            } else {
                const data = {
                    fromDate: moment()
                        .subtract(30, "days")
                        .format("YYYY-MM-DD"),
                    toDate: moment().format("YYYY-MM-DD"),
                };
                if (typeof dateData === "number") {
                    data.fromDate = moment()
                        .subtract(dateData, "days")
                        .format("YYYY-MM-DD");
                    return data;
                } else if (typeof dateData === "object") {
                    return dateData;
                }
                return data;
            }
        },
        async fetchHoursTechStraightOvertime() {
            const data = [
                {
                    key: "hours-per-by-tech-straight-overtime",
                    variables: {
                        // fromDate: "2025-01-30",
                        // toDate: "2025-01-30",
                        ...this.getDateData3(this.selectedDate3.value),
                    },
                },
            ];
            await this.$store.dispatch(
                "partner/fetchHoursTechStraightOvertime",
                {
                    items: data,
                },
            );
        },
        changeDate4(e) {
            this.selectedDate4 = e;
            if (e.value == "custom") {
                this.$refs["compRefs4"].openModal();
                return;
            }
            this.fetchNumberMarginByTech();
        },
        findDateResult4(e) {
            this.startDate4 = e.fromDate;
            this.endDate4 = e.toDate;
            this.fetchNumberMarginByTech();
        },

        getDateData4(dateData) {
            if (dateData == "custom") {
                const data = {
                    fromDate: this.startDate4,
                    toDate: this.endDate4,
                };
                return data;
            }
            if (dateData == 1) {
                const data = {
                    fromDate: moment().format("YYYY-MM-DD"),
                    toDate: moment().add(1, "days").format("YYYY-MM-DD"),
                };
                return data;
            } else {
                const data = {
                    fromDate: moment()
                        .subtract(30, "days")
                        .format("YYYY-MM-DD"),
                    toDate: moment().format("YYYY-MM-DD"),
                };
                if (typeof dateData === "number") {
                    data.fromDate = moment()
                        .subtract(dateData, "days")
                        .format("YYYY-MM-DD");
                    return data;
                } else if (typeof dateData === "object") {
                    return dateData;
                }
                return data;
            }
        },
        async fetchNumberMarginByTech() {
            const data = [
                {
                    key: "margin-by-tech",
                    variables: {
                        // fromDate: "2025-01-30",
                        // toDate: "2025-01-30",
                        ...this.getDateData4(this.selectedDate4.value),
                    },
                },
            ];
            await this.$store.dispatch("partner/fetchNumberOfMarginByTech", {
                items: data,
            });
        },
        changeDate5(e) {
            this.selectedDate5 = e;
            if (e.value == "custom") {
                this.$refs["compRefs5"].openModal();
                return;
            }
            this.changeCustomer2();
        },
        findDateResult5(e) {
            this.startDate5 = e.fromDate;
            this.endDate5 = e.toDate;
            this.changeCustomer2();
        },

        getDateData5(dateData) {
            if (dateData == "custom") {
                const data = {
                    fromDate: this.startDate5,
                    toDate: this.endDate5,
                };
                return data;
            }
            if (dateData == 1) {
                const data = {
                    fromDate: moment().format("YYYY-MM-DD"),
                    toDate: moment().add(1, "days").format("YYYY-MM-DD"),
                };
                return data;
            } else {
                const data = {
                    fromDate: moment()
                        .subtract(30, "days")
                        .format("YYYY-MM-DD"),
                    toDate: moment().format("YYYY-MM-DD"),
                };
                if (typeof dateData === "number") {
                    data.fromDate = moment()
                        .subtract(dateData, "days")
                        .format("YYYY-MM-DD");
                    return data;
                } else if (typeof dateData === "object") {
                    return dateData;
                }
                return data;
            }
        },
        async fetchfetchNumberTickets(value3) {
            const data = [
                {
                    key: "number-of-tickets",
                    variables: {
                        ...this.getDateData5(this.selectedDate5.value),
                        Customer: value3?.value || "",
                    },
                },
            ];
            await this.$store.dispatch("partner/fetchNumberOfTickets", {
                items: data,
            });
        },
        async fetchAllNumberTickets() {
            const data = [
                {
                    key: "all-number-of-tickets",
                    variables: {
                        ...this.getDateData5(this.selectedDate5.value),
                    },
                },
            ];
            await this.$store.dispatch("partner/fetchNumberOfTickets", {
                items: data,
            });
        },
        async changeCustomer2(selected) {
            this.selectedCustomers2 = selected ? selected.value : "All";

            if (this.selectedCustomers2.toLowerCase() === "all") {
                await this.fetchAllNumberTickets(selected);
            } else {
                await this.fetchfetchNumberTickets(selected);
            }
        },

        changeDate7(e) {
            this.selectedDate7 = e;
            if (e.value == "custom") {
                this.$refs["compRefs7"].openModal();
                return;
            }
            this.changeCustomer1();
        },
        findDateResult7(e) {
            this.startDate7 = e.fromDate;
            this.endDate7 = e.toDate;
            this.changeCustomer1();
        },

        getDateData7(dateData) {
            if (dateData == "custom") {
                const data = {
                    fromDate: this.startDate7,
                    toDate: this.endDate7,
                };
                return data;
            }
            if (dateData == 1) {
                const data = {
                    fromDate: moment().format("YYYY-MM-DD"),
                    toDate: moment().add(1, "days").format("YYYY-MM-DD"),
                };
                return data;
            } else {
                const data = {
                    fromDate: moment()
                        .subtract(30, "days")
                        .format("YYYY-MM-DD"),
                    toDate: moment().format("YYYY-MM-DD"),
                };
                if (typeof dateData === "number") {
                    data.fromDate = moment()
                        .subtract(dateData, "days")
                        .format("YYYY-MM-DD");
                    return data;
                } else if (typeof dateData === "object") {
                    return dateData;
                }
                return data;
            }
        },
        async fetchNumberJobsByTicketSize(value) {
            const data = [
                {
                    key: "number-of-jobs-by-ticket-size",
                    variables: {
                        ...this.getDateData7(this.selectedDate7.value),
                        Customer: value.value,
                    },
                },
            ];
            await this.$store.dispatch(
                "partner/fetchNumberOfJobsByTicketSize",
                {
                    items: data,
                },
            );
        },
        async fetchAllNumberJobsByTicketSize() {
            this.isLoading = true;
            const data = [
                {
                    key: "all-number-of-jobs-by-ticket-size",
                    variables: {
                        ...this.getDateData7(this.selectedDate7.value),
                    },
                },
            ];
            await this.$store.dispatch(
                "partner/fetchNumberOfJobsByTicketSize",
                {
                    items: data,
                },
            );
            this.isLoading = false;
        },
        async fetchCustomerList() {
            const data = [
                {
                    key: "customer-list",
                    variables: {},
                },
            ];
            await this.$store.dispatch("partner/fetchCustomerListData", {
                items: data,
            });
        },

        async changeCustomer1(selected) {
            this.selectedCustomer = selected ? selected.value : "All";

            if (this.selectedCustomer.toLowerCase() === "all") {
                await this.fetchAllNumberJobsByTicketSize(selected);
            } else {
                await this.fetchNumberJobsByTicketSize(selected);
            }
        },
        changeDate1(e) {
            this.selectedDate1 = e;
            if (e.value == "custom") {
                this.$refs["compRefs1"].openModal();
                return;
            }
            this.changeCustomer();
        },
        findDateResult1(e) {
            this.startDate1 = e.fromDate;
            this.endDate1 = e.toDate;
            this.changeCustomer();
        },

        getDateData1(dateData) {
            if (dateData == "custom") {
                const data = {
                    fromDate: this.startDate1,
                    toDate: this.endDate1,
                };
                return data;
            }
            if (dateData == 1) {
                const data = {
                    fromDate: moment().format("YYYY-MM-DD"),
                    toDate: moment().add(1, "days").format("YYYY-MM-DD"),
                };
                return data;
            } else {
                const data = {
                    fromDate: moment()
                        .subtract(30, "days")
                        .format("YYYY-MM-DD"),
                    toDate: moment().format("YYYY-MM-DD"),
                };
                if (typeof dateData === "number") {
                    data.fromDate = moment()
                        .subtract(dateData, "days")
                        .format("YYYY-MM-DD");
                    return data;
                } else if (typeof dateData === "object") {
                    return dateData;
                }
                return data;
            }
        },
        async changeCustomer(selected) {
            this.selectedCustomers1 = selected ? selected.value : "All";

            if (this.selectedCustomers1.toLowerCase() === "all") {
                await this.fetchAllNonProdHoursByTech(selected);
            } else {
                await this.fetchNonProdHoursByTech(selected);
            }
        },
        async fetchNonProdHoursByTech(value1) {
            this.isLoading = true;
            const dataList = [
                {
                    key: "non-productive-hours-by-tech",
                    variables: {
                        ...this.getDateData1(this.selectedDate1.value),
                        Customer: value1.value,
                    },
                },
            ];
            await this.$store.dispatch("partner/fetchNoOfNonProdHoursByTech", {
                items: dataList,
            });
            this.isLoading = false;
        },
        async fetchAllNonProdHoursByTech() {
            this.isLoading = true;
            const dataList = [
                {
                    key: "all-non-productive-hours-by-tech",
                    variables: {
                        ...this.getDateData1(this.selectedDate1.value),
                    },
                },
            ];
            await this.$store.dispatch("partner/fetchNoOfNonProdHoursByTech", {
                items: dataList,
            });
            this.isLoading = false;
        },
        findDateResult6(e) {
            this.startDate2 = e.fromDate;
            this.endDate2 = e.toDate;
            this.currentPage = 1;
            this.fetchSlaReport();
        },
        changeDate6(e) {
            if (e.value == "custom") {
                this.$refs["compRefs6"].openModal();
                return;
            }
            this.currentPage = 1;
            this.fetchSlaReport();
        },
        async fetchSlaReport() {
            this.slaReportLoading = true;
            try {
                await this.$store.dispatch("partner/fetchSlaReportList", {
                    items: [
                        {
                            key: "sla-report",
                            variables: {
                                ...this.getDateInfo(this.selectedDate8.value),
                            },
                        },
                    ],
                    pagination: {
                        page: this.currentPage,
                        pageSize: this.perPage,
                    },
                });
            } catch (error) {
                this.$swal({
                    title: "Error",
                    text: error.message,
                    type: "error",
                });
            } finally {
                this.slaReportLoading = false;
            }
        },
        onChangePage(page) {
            this.currentPage = page;
            this.fetchSlaReport();
        },
        getDateInfo(dateData) {
            if (dateData == "custom") {
                const data = {
                    fromDate: this.startDate2,
                    toDate: this.endDate2,
                };
                return data;
            }
            if (typeof dateData === "number") {
                const data = {
                    fromDate: moment()
                        .subtract(dateData, "days")
                        .format("YYYY-MM-DD"),
                    toDate: moment().format("YYYY-MM-DD"),
                };
                return data;
            }
        },
    },
    async mounted() {
        await this.changeCustomer1();
        await this.changeCustomer();
        await this.changeCustomer2();
        await this.fetchHoursTechStraightOvertime();
        await this.fetchNumberMarginByTech();
        await this.fetchCustomerList();
        this.fetchSlaReport();
    },
};
</script>
